import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Scrollbar, A11y } from 'swiper';
import { Link } from 'react-router-dom';

const TouristPlaces = (props) => {
    const data = props.data;

    return (
        <section className="tf-section best-rooms" style={{ backgroundColor: '#f9f5ec' }}>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="block-text center text-black">
                            <h1 className="heading-bg" data-aos="fade-in" data-aos-duration="1000"><span>Turismo</span></h1>
                            <h5 className="sub-title mb-10 text-black" data-aos="fade-up" data-aos-duration="1000">¿Qué hacer en Tucumán?</h5>
                        </div>
                    </div>
                </div>
                <div className="row mt-50">
                    <div className="col-12" data-aos="fade-up" data-aos-duration="1000">
                        <Swiper
                            className="best-rooms-swiper"
                            modules={[Navigation, Scrollbar, A11y]}
                            spaceBetween={30}
                            navigation={true}
                            breakpoints={{
                                0: { slidesPerView: 1 },
                                767: { slidesPerView: 2 },
                                991: { slidesPerView: 3 },
                            }}
                            style={{
                                "--swiper-navigation-color": "#df4421"
                            }}
                        >
                            {
                                data.map((item, index) => (
                                    <SwiperSlide key={item.id || index} className="best-room-slide">
                                        <div className="best-room-card" style={{ backgroundColor: '#fff', borderRadius: '15px', overflow: 'hidden' }}>
                                            <div className="best-room-image-container">
                                                <img src={item.img} alt={item.title} className="best-room-image" />
                                            </div>
                                            <div className="best-room-content" style={{ padding: '25px', display: 'flex', flexDirection: 'column', height: '100%' }}>
                                                <h4 className="best-room-title text-black" style={{ marginBottom: '15px', minHeight: '30px' }}>
                                                    {item.title}
                                                </h4>
                                                <p className="best-room-desc text-black" style={{ marginBottom: '20px', minHeight: '100px' }}>
                                                    {item.desc}
                                                </p>
                                                <Link to="/que-hacer" className="btn-action style-2 best-room-btn" style={{ marginTop: 'auto', alignSelf: 'flex-start' }}>
                                                    Más Info <i className="fas fa-arrow-right"></i>
                                                </Link>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))
                            }
                        </Swiper>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default TouristPlaces;
